<form [formGroup]="registerForm" (ngSubmit)="signUp()" class="relative" [class.margin-cart]="cart">

  <div *ngIf="!f.invalid && success" class="alert alert-success" role="alert">
    <a href="#" class="alert-link"> {{username}} {{ "signup.create-user-success" | lang }} </a>
  </div>

  <div *ngIf="error" class="alert alert-danger" role="alert">
    <a class="alert-link"> {{ error.message }} </a>
  </div>

  <div *ngIf="timeoutError" class="alert alert-danger" role="alert">
    <a class="alert-link" lang>auth.error</a>
  </div>

  <!-- Username -->
  <div class="form-group input-group">
    <input name="username" formControlName="username" class="form-control form-input"
      placeholder="{{ 'auth.username-placeholder' | lang }}" type="text"
      [ngClass]="{ 'is-invalid': submitted && f.username.errors }">

  </div> <!-- form-group// -->

  <!-- Email -->
  <div class="form-group input-group" *ngIf="!externalEmail">
    <input name="email" formControlName="email" class="form-control form-input" placeholder="{{ 'common.email' | lang }}"
      type="email" [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
  </div> <!-- form-group// -->

  <!-- Password -->
  <div class="form-group input-group">
    <input name="password" class="form-control form-input" placeholder="{{ 'signup.password-placeholder' | lang }}"
      formControlName="password" type="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
  </div> <!-- form-group// -->

  <!-- Confirm password -->

  <div class="form-group input-group">
    <input name="confirmPassword" class="form-control form-input" formControlName="confirmPassword"
      placeholder="{{ 'signup.confirm-password-placeholder' | lang }}" type="password"
      [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }">
  </div> <!-- form-group// -->

  <!-- Register button -->
  <div class="form-group" *ngIf="showButton">
    <button class="btn register" lang>actions.register</button>
  </div> <!-- form-group// -->

  <!-- Spinner  -->

  <hs-spinner [show]="loading && showButton"></hs-spinner>

</form>